import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getContainerStyles } from '../../../../utils/Utils';

export default class FullbleedWrapper extends Component {
  render() {
    const {
      children,
      backgroundColor,
    } = this.props;
    return (
      <section
        className="fullbleed-wrapper"
        style={getContainerStyles(backgroundColor)}
      >
        {children}
      </section>
    );
  }
}

FullbleedWrapper.propTypes = {
  backgroundColor: PropTypes.object,
};
